<template>
    <v-dialog
        v-model="visible"
        width="500"
    >
        <v-card>
          <v-card-title style="font-size: 2em">
              Cannot Create Challenge
          </v-card-title>
          <v-card-text style="font-size: 1.3em">
              You must provide at least one date for the challenge
          </v-card-text>
          <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="orange"
            text
            @click="$emit('update:visible', false)"
          >
            OK
          </v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
  name: 'DeleteChallengeDialog',

  props: ['visible']
}
</script>
